<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('choose_evg_combine_sku_table_search')"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      v-el-dialog-drag
      :modal-append-to-body="false"
      :modal="false"
    >
      <el-form ref="form" :model="form" label-width="90px" size="small">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_evgCombineNo') || '产品编号'">
              <el-input
                v-model.trim="form.evgCombineNo"
                :placeholder="
                  $l('form_placeholder_evgCombineNo') || '请输入产品编号'
                "
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_eanCode') || 'UPC'">
              <el-input
                v-model.trim="form.eanCode"
                :placeholder="$l('form_placeholder_eanCode') || '请输入UPC'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_combineName') || '产品名称'">
              <el-input
                v-model.trim="form.combineName"
                :placeholder="
                  $l('form_placeholder_combineName') || '请输入产品名称'
                "
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_combineColor') || '产品颜色'">
              <el-input
                v-model.trim="form.combineColor"
                :placeholder="
                  $l('form_placeholder_combineColor') || '请输入产品颜色'
                "
                clearable
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_combinePattern') || '产品花型'"
            >
              <el-input
                v-model.trim="form.combinePattern"
                :placeholder="
                  $l('form_placeholder_combinePattern') || '请输入产品花型'
                "
                clearable
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$l('form_label_combineStyle') || '产品款式'">
              <el-input
                v-model.trim="form.combineStyle"
                :placeholder="
                  $l('form_placeholder_combineStyle') || '请输入产品花型'
                "
                clearable
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$l('form_label_combineSize') || '产品尺寸'">
              <el-input
                v-model.trim="form.combineSize"
                :placeholder="
                  $l('form_placeholder_combineSize') || '请输入产品尺寸'
                "
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_customer') || '所属客户'">
              <dict-select
                v-model="form.listCustCode"
                url="/master/common/dict/customerSelect"
                :placeholder="
                  $l('form_placeholder_customer') || '请选择所属客户'
                "
                filterable
                multiple
                clearable
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_brandCode') || '产品品牌'">
              <dict-select
                v-model="form.listBrandCode"
                url="/master/common/dict/brandSelect"
                :placeholder="$l('form_placeholder_brandCode') || '请选择产品品牌'"
                filterable
                clearable
                multiple
                style="width:100%"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_masterCategory') || '产品分类'"
            >
              <dict-select
                v-model="form.listMasterCategoryCode"
                url="/master/masterCategory/select"
                :body="{ parentCode: 'ABSHome' }"
                :placeholder="
                  $l('form_placeholder_masterCategory') || '请选择产品分类'
                "
                filterable
                clearable
                multiple
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '' }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) this.$emit('reset')
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
